import settings from '../conf'
import { fetchBaseQuery } from '@reduxjs/toolkit/query'
import { errorReporing } from '../utils'
import { OFFLINE_ALERT, ERROR_ALERT } from '../trans'
import { addMessage } from '../slices/ui

export const rawBaseQuery = fetchBaseQuery({
  baseUrl: settings.API_URL,
  prepareHeaders(headers) {
    //headers.set("Content-Type", "multipart/form-data")
    return headers;
  },
  credentials: "include"
})

export const apiBaseQuery = (arg, api, extraOptions) => {
  return new Promise((resolve, reject) => {
    let retray = 0;
    const apiCall = () => {
      const query = rawBaseQuery(arg, api, extraOptions)
      const callUrl = window.location.href
      query.then((result)=>{
        if (result.error){

          if (navigator.onLine === false){
            api.dispatch(addMessage({
              message:OFFLINE_ALERT,
              timeout: 3,
              status: 'waring'
            }))
            const offlineResult = {...result}
            offlineResult.data = null
            resolve(offlineResult);
            return
          }

          if (result.meta.response && result.meta.response.status == 404){
            const error = {
              'error': 'Api 404 ' + result.meta.request.url,
              'stack': result.error.status + ' ' + JSON.stringify(result.error.data?.detail || '') + ' \n ' + new Error().stack,
              'url': callUrl 
            }
            errorReporing(error)
            api.dispatch(addMessage({
              message:ERROR_ALERT,
              timeout: 5,
              status: 'error'
            }))
            reject("api 404")
            return
          }

          if (result.meta.response && result.meta.response.status == 500){
            api.dispatch(addMessage({
              message:ERROR_ALERT,
              timeout: 5,
              status: 'error'
            }))
            resolve(null)
            return
          }

          if (result.error?.status == 'FETCH_ERROR' && retray <= 9){
            const timeout = setTimeout(()=>{
              apiCall();
            }, 250 + 100 * Math.pow(1.5, retray) );
            api.signal.addEventListener('abort', () => {
              clearTimeout(timeout);
            });
            retray += 3
            return
          }

          const error = {
            'error': 'Api error ' + result.meta.request.url,
            'stack': result.error.status + ' ' + JSON.stringify(result.error.data?.detail || '')  + ' \n ' + new Error().stack,
            'url': callUrl 
          }
          errorReporing(error)
          api.dispatch(addMessage({
            message:ERROR_ALERT,
            timeout: 5,
            status: 'error'
          }))
          reject("api error")
        }


        if (result.meta.response && result.meta.response.status == 202){
          retray += 1;
          if (retray > 15){
            const error = {
              'title': 'Task expiried ' + result.meta.request.url,
              'stack': new Error().stack,
              'url': callUrl 
            }
            errorReporing(error)
            reject({
              error: error 
            })
          } else {
            const timeout = setTimeout(()=>{
              apiCall();
            }, 250 + 100 * Math.pow(1.5, retray) );
            api.signal.addEventListener('abort', () => {
              clearTimeout(timeout);
            });
          }
        } else {
          resolve(result);
        }
      })
    }
    apiCall()
  })
}
